module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/minimal_2-723edbee8569cfaaeeefac91d1e5b8f3.png";